function AccountMapperRepoNew({ GRAPHQL_URL, GRAPHQL_API_KEY, httpClient }) {
  this.findAllAccounts = ({ success, failure }) => {
    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        headers: {
          'x-api-key': GRAPHQL_API_KEY
        },
        data: {
          query: `query MyQuery {
                          listAccounts {
                            accountId
                            accountName
                            createdDate
                            email
                            status
                            id
                            masterRefId
                          }
                        }`
        }
      },
      {
        success: (response) => success(response.data.data.listAccounts),
        failure: (error) => failure(error)
      }
    )
  }
}

export default AccountMapperRepoNew
